import { useEffect, useState } from "react";
import { Tag, ShoppingBag, Star } from "lucide-react";
import api from "@/lib/api";
import { CONDITION_SHORT } from "@/components/ConditionBadge";

function ago(iso) {
  const s = (Date.now() - new Date(iso).getTime()) / 1000;
  if (s < 60) return "just now";
  if (s < 3600) return `${Math.floor(s / 60)}m ago`;
  if (s < 86400) return `${Math.floor(s / 3600)}h ago`;
  return `${Math.floor(s / 86400)}d ago`;
}

function shortCond(c) {
  return CONDITION_SHORT?.[c] || String(c || "").split("/")[0].trim();
}

function EventItem({ e }) {
  if (e.type === "sold") {
    return (
      <span className="inline-flex items-center gap-2 whitespace-nowrap">
        <ShoppingBag className="h-3.5 w-3.5 text-link" />
        <span className="text-ink font-bold uppercase text-[10px] tracking-wider">Just sold</span>
        <span className="text-subtle">{e.name}{e.state ? ` · to a host in ${e.state}` : ""}</span>
        <span className="text-subtle/60">{ago(e.when)}</span>
      </span>
    );
  }
  return (
    <span className="inline-flex items-center gap-2 whitespace-nowrap">
      <Tag className="h-3.5 w-3.5 text-link" />
      <span className="text-ink font-bold uppercase text-[10px] tracking-wider">Just listed</span>
      <span className="text-subtle">{e.name}{e.condition ? ` · ${shortCond(e.condition)}` : ""}</span>
      <span className="text-subtle/60">{ago(e.when)}</span>
    </span>
  );
}

export function LiveActivityTicker() {
  const [events, setEvents] = useState([]);

  useEffect(() => {
    api.get("/activity").then((r) => setEvents(r.data.events || [])).catch(() => {});
  }, []);

  if (!events.length) return null;
  const loop = [...events, ...events];

  return (
    <div data-testid="live-activity-ticker" className="border-b-2 border-ink bg-paper overflow-hidden">
      <style>{`@keyframes str-marquee{0%{transform:translateX(0)}100%{transform:translateX(-50%)}}.str-marquee-track{animation:str-marquee 40s linear infinite}.str-marquee-track:hover{animation-play-state:paused}`}</style>
      <div className="flex items-stretch">
        <a
          href="https://www.doublerainbowsuites.com"
          target="_blank"
          rel="noopener noreferrer"
          data-testid="parent-company-badge"
          className="shrink-0 bg-ink text-paper px-4 py-2.5 flex items-center gap-2 font-mono text-[10px] uppercase tracking-wider hover:bg-link transition-colors"
        >
          <Star className="h-3.5 w-3.5 fill-current" />
          <span className="hidden sm:inline">Powered by Double Rainbow Suites · 5 yrs in STR · 4.9★ Superhosts</span>
          <span className="sm:hidden">Double Rainbow Suites · 5 yrs STR</span>
        </a>
        <div className="relative flex-1 overflow-hidden py-2.5">
          <div className="str-marquee-track flex gap-8 w-max font-mono text-xs px-6">
            {loop.map((e, i) => (
              <span key={i} className="flex items-center gap-8">
                <EventItem e={e} />
                <span className="text-subtle/30">◆</span>
              </span>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
